// Central Jeremy config — everything here is intended to be admin-editable in future phases.
// Contact info is placeholder until Jeremy approves publishing.

export const JEREMY = {
  name: "Jeremy",
  fullBrand: "Jeremy with ION Solar",
  role: "Your Local Virginia Solar Guide",
  city: "Fredericksburg, Virginia",
  positioning: "Your Local Virginia Solar Guide",
  mission:
    "I help Virginia homeowners understand their electric bills, explore solar without the pressure, and determine whether an ION Solar Power Purchase Agreement makes sense for their home.",
  taglines: [
    "A Local Expert. A Personal Experience. A Trusted Solar Company.",
    "Virginia Solar Without the Sales Pressure.",
    "I Help Homeowners Take Back Control of Their Electric Bills.",
    "We Power People — One Home at a Time.",
  ],
  facts: [
    "Virginia solar professional",
    "Virginia homeowner advocate",
    "Utility-bill analysis",
    "PPA education",
    "Roof and property qualification",
    "Personal support through every step",
  ],
  serviceAreas: [
    "Fredericksburg",
    "Stafford County",
    "Spotsylvania County",
    "King George County",
    "Caroline County",
    "Orange County",
    "Culpeper County",
    "Prince William County",
    "Northern Virginia",
    "Richmond-area communities",
  ],
  // Placeholder contact — replace via admin once Jeremy approves publishing.
  contact: {
    phone: "(826) 251-1538",
    text: "(826) 251-1538",
    email: "j.jefferson@IONsolar.com",
    hours: "Mon–Sat · 9am–7pm ET",
    responseTime: "Typically within 2 business hours",
    isPlaceholder: false,
  },
};

// Homepage hero uses the new arms-crossed sunset caricature.
// Meet Jeremy uses the new "pointing at solar panels with tablet" caricature.
// The original real photos remain available for other placements.
export const PHOTOS = {
  hero: "https://customer-assets-39nsmqrw.emergentagent.net/job_solar-ppa-qualify/artifacts/32b2du3n_image.png",
  meet: "https://customer-assets-39nsmqrw.emergentagent.net/job_solar-ppa-qualify/artifacts/xvzue9w6_image.png",
  casual: "https://customer-assets-39nsmqrw.emergentagent.net/job_solar-ppa-qualify/artifacts/o0uwjw64_image.png",
  character: "https://customer-assets-39nsmqrw.emergentagent.net/job_solar-ppa-qualify/artifacts/pecoupvq_IMG_6134%202.JPG",
};

export const ASK_JEREMY_QA = [
  {
    q: "Could my home qualify?",
    a: "Qualification depends on your roof condition, sun exposure, utility territory, ownership, and credit review. If you share your address and a recent electric bill, I can give you a straight answer — no obligation, no pressure.",
    cta: { label: "See if my home qualifies", to: "/qualify" },
  },
  {
    q: "How does a solar PPA work?",
    a: "With a Power Purchase Agreement, the system owner installs and maintains solar panels on your roof at no upfront cost, and you purchase the clean energy the system produces at a predictable rate. You buy the power — not the equipment.",
    cta: { label: "How solar works", to: "/how-solar-works" },
  },
  {
    q: "What is net metering?",
    a: "Net metering is the agreement between your home and your utility to exchange clean energy back and forth. Each qualifying kilowatt-hour you send to the grid can offset a kilowatt-hour you pull back later, subject to utility rules.",
    cta: { label: "Read the full explainer", to: "/how-solar-works" },
  },
  {
    q: "What happens if I move?",
    a: "The ION agreement may be assumable by an eligible buyer, and applicable warranties and guarantees may transfer according to their terms. A predictable rate can be attractive to prospective buyers — no increase in home value or sale speed is guaranteed.",
    cta: { label: "Moving & selling FAQ", to: "/homeowner-questions" },
  },
  {
    q: "What about my roof?",
    a: "Mounts are attached to structural roof members per engineering and installation requirements. Workmanship is covered by a 10-year written warranty. Older or damaged roofs may need repair before installation.",
    cta: { label: "Roof & warranty details", to: "/homeowner-questions" },
  },
  {
    q: "How do I send you my utility bill?",
    a: "The fastest way is the secure upload on the qualification page — PDF, JPG, PNG, or HEIC. I only share it with authorized ION support personnel, and you can request deletion any time.",
    cta: { label: "Upload my bill", to: "/qualify?upload=1" },
  },
  {
    q: "Can I schedule a call?",
    a: "Yes — the qualification form has an optional appointment picker, or you can text me directly. My hours are typically Mon–Sat, 9am–7pm ET.",
    cta: { label: "Schedule a call", to: "/qualify" },
  },
];
